// extracted by mini-css-extract-plugin
export const headerCentered = "ContentWithSideCard-module--header-centered--15TcJ";
export const container = "ContentWithSideCard-module--container--1x9B2";
export const card = "ContentWithSideCard-module--card--2jgCd";
export const content = "ContentWithSideCard-module--content--9lkyv";